module.exports = __webpack_public_path__ + "img/Elements site web.b39df7ff.gif";